module.exports = __webpack_public_path__ + "img/zhaocha_des_3.51405bd6.jpg";